import React from "react";
import OutletCard from "../../components/OutletCard/OutletCard";
import { Card } from "reactstrap";
import CategoryFilter from "../../components/CategoryFilter/CategoryFilter";
import { useCustomizeShop } from "./_hooks/useCustomizeShop";
import { CustomizeShopCategories } from "./CustomizeShop.constants";
import "./CustomizeShop.scss";
import Banners from "./components/Banners";

const CustomizeShop = () => {
  const {
    handleCategorySelect,
    state,
    uploadBanner,
    currentCategory,
    deleteBanner,
  } = useCustomizeShop();

  return (
    <OutletCard>
      <Card className="d-flex flex-column justify-content-between flex-row flex-wrap gap-3 bg-light customize-shop">
        <CategoryFilter
          categories={CustomizeShopCategories}
          onSelect={handleCategorySelect}
          currentCategory="Banners"
          iconAlignLeft={true}
        />
        {currentCategory === "Banners" && (
          <Banners
            banners={state?.banners}
            uploadBanner={uploadBanner}
            deleteBanner={deleteBanner}
          />
        )}
      </Card>
    </OutletCard>
  );
};

export default CustomizeShop;
